import { render, staticRenderFns } from "./h3-mescroll.vue?vue&type=template&id=21f1991a&scoped=true&"
import script from "./h3-mescroll.vue?vue&type=script&lang=ts&"
export * from "./h3-mescroll.vue?vue&type=script&lang=ts&"
import style0 from "./h3-mescroll.vue?vue&type=style&index=0&id=21f1991a&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../entries/portal/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f1991a",
  null
  
)

export default component.exports